import { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
`;

const PhoneInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const FixedPrefix = styled.div`
  padding: 10px 8px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
  width: 50px;
  text-align: center;
  flex-shrink: 0;
`;

const Input = styled.input`
  padding: 10px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  transition: border-color 0.3s ease;
  width: 70px;
  flex-shrink: 0;

  &:focus {
    outline: none;
    border-color: #007bff;
  }

  &::placeholder {
    color: #999;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const Separator = styled.span`
  color: #999;
  font-size: 14px;
  flex-shrink: 0;
`;

const ErrorMessage = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #dc3545;
`;

const PhoneInput = ({ label = "전화번호", value = '', onChange, error, disabled = false }) => {
  // value를 010-XXXX-XXXX 형식으로 받아서 파싱
  const parsePhone = (phoneString) => {
    if (!phoneString) return { middle: '', last: '' };
    const parts = phoneString.replace(/^010-?/, '').split('-');
    return {
      middle: parts[0] || '',
      last: parts[1] || ''
    };
  };

  const { middle: initialMiddle, last: initialLast } = parsePhone(value);
  const [middle, setMiddle] = useState(initialMiddle);
  const [last, setLast] = useState(initialLast);

  const handleMiddleChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // 숫자만 허용
    if (value.length <= 4) {
      setMiddle(value);
      updateParent(value, last);

      // 4자리 입력 완료 시 다음 input으로 자동 포커스
      if (value.length === 4 && e.target.nextElementSibling?.nextElementSibling) {
        e.target.nextElementSibling.nextElementSibling.focus();
      }
    }
  };

  const handleLastChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // 숫자만 허용
    if (value.length <= 4) {
      setLast(value);
      updateParent(middle, value);
    }
  };

  const updateParent = (middleVal, lastVal) => {
    if (middleVal || lastVal) {
      onChange(`010-${middleVal}-${lastVal}`);
    } else {
      onChange('');
    }
  };

  return (
    <Container>
      {label && <Label>{label}</Label>}
      <PhoneInputWrapper>
        <FixedPrefix>010</FixedPrefix>
        <Separator>-</Separator>
        <Input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="1234"
          value={middle}
          onChange={handleMiddleChange}
          disabled={disabled}
          maxLength={4}
        />
        <Separator>-</Separator>
        <Input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="5678"
          value={last}
          onChange={handleLastChange}
          disabled={disabled}
          maxLength={4}
        />
      </PhoneInputWrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};

export default PhoneInput;
